var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"refresh",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.reload()}}},[_c('span',{staticClass:"material-icons"},[_vm._v("refresh")])])}
var staticRenderFns = []

export { render, staticRenderFns }